import axios from 'axios';

export const bffClient = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_BFF_ENDPOINT}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30 * 1000,
});

export const pharmakonProxyClient = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_BFF_ENDPOINT}/proxy`,
  headers: {
    'Content-Type': 'application/vnd.api+json',
  },
  timeout: 30 * 1000,
});
